<div
  class="vendor-device-scan__overlay"
  *ngIf="isVisible"
  role="dialog"
  aria-modal="true"
  aria-label="Scan membership barcode using the shop's device"
>
  <div class="vendor-device-scan__container">
    <header class="vendor-device-scan__header">
      <button
        type="button"
        class="vendor-device-scan__close"
        (click)="onClose()"
        [disabled]="isProcessing"
        aria-label="Close"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div
      class="order-request-membership-device-wait"
      role="status"
      aria-live="polite"
      [attr.aria-busy]="!showManualEntry || isProcessing"
      aria-labelledby="vendor-device-scan-message"
    >
      <div class="vendor-device-scan__scanner" aria-hidden="true">
        <svg
          class="vendor-device-scan__scanner-svg"
          viewBox="0 0 240 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="240" height="88" rx="16" fill="#F4F6FA" />
          <g fill="#15172E" transform="translate(28 18)">
            <rect x="0" y="0" width="3" height="52" rx="1" />
            <rect x="6" y="0" width="2" height="52" rx="1" />
            <rect x="11" y="0" width="5" height="52" rx="1" />
            <rect x="19" y="0" width="2" height="52" rx="1" />
            <rect x="24" y="0" width="2" height="52" rx="1" />
            <rect x="29" y="0" width="4" height="52" rx="1" />
            <rect x="36" y="0" width="2" height="52" rx="1" />
            <rect x="41" y="0" width="3" height="52" rx="1" />
            <rect x="47" y="0" width="2" height="52" rx="1" />
            <rect x="52" y="0" width="5" height="52" rx="1" />
            <rect x="60" y="0" width="2" height="52" rx="1" />
            <rect x="65" y="0" width="3" height="52" rx="1" />
            <rect x="71" y="0" width="2" height="52" rx="1" />
            <rect x="76" y="0" width="4" height="52" rx="1" />
            <rect x="83" y="0" width="2" height="52" rx="1" />
            <rect x="88" y="0" width="2" height="52" rx="1" />
            <rect x="93" y="0" width="5" height="52" rx="1" />
            <rect x="101" y="0" width="2" height="52" rx="1" />
            <rect x="106" y="0" width="3" height="52" rx="1" />
            <rect x="112" y="0" width="2" height="52" rx="1" />
            <rect x="117" y="0" width="4" height="52" rx="1" />
            <rect x="124" y="0" width="2" height="52" rx="1" />
            <rect x="129" y="0" width="3" height="52" rx="1" />
            <rect x="135" y="0" width="2" height="52" rx="1" />
            <rect x="140" y="0" width="5" height="52" rx="1" />
            <rect x="148" y="0" width="2" height="52" rx="1" />
            <rect x="153" y="0" width="2" height="52" rx="1" />
            <rect x="158" y="0" width="3" height="52" rx="1" />
            <rect x="164" y="0" width="2" height="52" rx="1" />
            <rect x="169" y="0" width="5" height="52" rx="1" />
            <rect x="177" y="0" width="2" height="52" rx="1" />
            <rect x="182" y="0" width="3" height="52" rx="1" />
          </g>
          <g class="vendor-device-scan__beam">
            <rect x="16" y="0" width="208" height="32" fill="url(#vendorDeviceScanBand)" />
            <rect x="16" y="15" width="208" height="2" rx="1" fill="#0CF0BB" />
          </g>
          <defs>
            <linearGradient id="vendorDeviceScanBand" x1="120" y1="0" x2="120" y2="32">
              <stop stop-color="#0CF0BB" stop-opacity="0" />
              <stop offset="0.45" stop-color="#0CF0BB" stop-opacity="0.55" />
              <stop offset="0.55" stop-color="#0CF0BB" stop-opacity="0.55" />
              <stop offset="1" stop-color="#0CF0BB" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <p id="vendor-device-scan-message" class="order-request-membership-device-wait__message">
        {{ message }}
      </p>
    </div>

    <!-- Fallback once no scan has arrived: type or paste the membership ID. -->
    <div class="vendor-device-scan__manual" *ngIf="showManualEntry">
      <label class="vendor-device-scan__manual-label" for="vendor-device-scan-manual-input">
        No scan detected. Enter the membership ID instead.
      </label>
      <div class="vendor-device-scan__manual-row">
        <input
          #manualInput
          id="vendor-device-scan-manual-input"
          type="text"
          class="vendor-device-scan__manual-input"
          placeholder="Membership ID"
          autocomplete="off"
          [(ngModel)]="manualValue"
          [disabled]="isProcessing"
          (keydown.enter)="onManualSubmit()"
        />
        <button
          type="button"
          class="vendor-device-scan__manual-submit"
          (click)="onManualSubmit()"
          [disabled]="!canSubmitManualValue"
        >
          Verify
        </button>
      </div>
      <p class="vendor-device-scan__manual-hint">
        You can still scan with the shop's device — it will be picked up automatically.
      </p>
    </div>

    <!-- Dismissal is the header close button; no duplicate cancel here. -->
    <footer class="vendor-device-scan__footer" *ngIf="!showManualEntry">
      <button
        type="button"
        class="vendor-device-scan__manual-trigger"
        (click)="onEnterManuallyClick()"
        [disabled]="isProcessing"
      >
        Enter manually
      </button>
    </footer>
  </div>
</div>
